import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  itemSubject: Subject<any> = new Subject<any>();

  constructor() { }

  buyItem(item) {
    this.itemSubject.next(item)
  }
}
